import { Component, OnInit } from '@angular/core';
import { DownloadService } from 'src/app/base/services/download.service';

@Component({
  selector: 'app-competitions',
  templateUrl: './competitions.component.html',
  styleUrls: ['./competitions.component.scss']
})
export class CompetitionsComponent implements OnInit {

  constructor(private downloadService: DownloadService) { }

  ngOnInit(): void {
  }

  download(name: string, ext: string = null, path: string = null) {
    this.downloadService.download(path, name, ext);
  }
  

}
